module.exports = __webpack_public_path__ + "img/W-24.38e31570.jpg";